module.exports = __webpack_public_path__ + "img/美乐象象.32e2a112.png";